var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14.583H3.5V12.7497H14.5V14.583ZM14.5 10.9163H3.5V9.08301H14.5V10.9163ZM14.5 7.24967H3.5V5.41634H14.5V7.24967ZM0.75 19.1663L2.125 17.7913L3.5 19.1663L4.875 17.7913L6.25 19.1663L7.625 17.7913L9 19.1663L10.375 17.7913L11.75 19.1663L13.125 17.7913L14.5 19.1663L15.875 17.7913L17.25 19.1663V0.833008L15.875 2.20801L14.5 0.833008L13.125 2.20801L11.75 0.833008L10.375 2.20801L9 0.833008L7.625 2.20801L6.25 0.833008L4.875 2.20801L3.5 0.833008L2.125 2.20801L0.75 0.833008V19.1663Z",
    fill: "#F5F5F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/orderIcon.bbf0a930.svg";
export { ForwardRef as ReactComponent };